import { AdminLocalStorageService } from './admin-local-storage.service';
import { Injectable } from '@angular/core';
import {
	CognitoUserPool,
	CognitoUserAttribute,
	CognitoUser,
    AuthenticationDetails,
} from 'amazon-cognito-identity-js';
import { Observable } from 'rxjs';

@Injectable()
export class AuthenticationService {

    private poolData = {
        UserPoolId: 'eu-central-1_rGl2reFjn', // Your user pool id here
        ClientId: '6dm9vd98ep65dtk2r3fgaipp2a', // Your client id here
    };
    private cognitoUser :CognitoUser = null;

    private userPool : any;


    constructor(
        private localStorage: AdminLocalStorageService) {
            // this.userPool = new CognitoUserPool(this.poolData)
    }

    isAuthenticated(){
        var token = this.localStorage.getToken();
        return token != null;
    }


    // getUser(userName : string){
	//     if (this.cognitoUser===null){
    //         var userPool = new CognitoUserPool(this.poolData);
    //         // var userData = {
    //         //     Username : userName,
    //         //     Pool : userPool
    //         //     };
    //         // this.cognitoUser = new CognitoUser(userData);
	//     }
	//     return this.cognitoUser;
    // }

    // signInUser(userName: string, password:string) : Observable<any> {
    //     let authenticationData = {
    //         Username : userName,
    //         Password : password,
    //     };
    //     var authenticationDetails = new AuthenticationDetails(authenticationData);
    //     return new Observable<any>( (observer) => {
    //         this.getUser(userName).authenticateUser(authenticationDetails, {
    //             onFailure: (err)=>{
    //                 observer.error(err)
    //                 observer.complete();
    //             },
	// 		    onSuccess: (result)=>{
    //                 observer.next(result);
    //                 observer.complete();
    //             }
    //         });
    //     })
    // }


    // signOutUser() : Observable<any> {
    //     return new Observable<any>( (observer) => {
    //         if (this.cognitoUser != null){
    //             if (this.cognitoUser.getSignInUserSession() != null){
    //                 this.cognitoUser.signOut();
    //                 this.cognitoUser = null;
    //                 observer.next("User signed out");
    //                 observer.complete
    //                 return;
    //             }
    //         }	
    //         observer.error("User is not signed in")
    //     })
    // }


    
    


}
